<template>
  <div>
    <template>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXABSurveyResultsList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <Loader v-if="isLoading"></Loader>
            <b-row v-else>
              <b-col cols="12" class="ml-3">
                <p v-if="retrieved.idSurvey.surveyTitle"><b>{{$t('views.exaborganizationlead.form.title')}}: </b><span>{{retrieved.idSurvey.surveyTitle}}</span></p>
                <p v-if="retrieved.idSurvey.surveyDescription"><b>{{$t('views.exaborganizationlead.form.description')}}: </b><span>{{retrieved.idSurvey.surveyDescription}}</span></p>
                <p v-if="retrieved.createdAt"><b>{{$t('views.excmcase.show.created')}}: </b><span>{{$moment(retrieved.createdAt).format('YYYY-MM-DD HH:mm')}}</span></p>
                <p v-if="retrieved.idUserData"><b>{{$t('views.exaborganizationlead.form.idUserData')}}</b>:
                  <router-link v-if="retrieved.idUserData && retrieved.idUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: retrieved.idUserData['@id'] }}">
                    {{ retrieved.idUserData.name }} {{ retrieved.idUserData.surname }}
                  </router-link>
                  <router-link v-else-if="retrieved.idUserData" :to="{name: 'FirmShow', params: { id: retrieved.idUserData['@id'] }}">
                    {{ retrieved.idUserData.firmname1 === '' ? retrieved.idUserData.fullName : retrieved.idUserData.firmname1 }}
                  </router-link>
                </p>
              </b-col>
              <b-col cols="12">
                <b-col
                  cols="12"
                  v-for="(surveyGroupsQuestion, groupsQuestionsKey) in retrieved.form.surveyGroupsQuestions"
                  :key="groupsQuestionsKey"
                >
                  <b-col cols="12" class="mt-4 pt-0 ml-0 pl-0" v-if="groupsQuestionsKey > 0">
                    <div style="border-bottom: 2px dotted grey;"></div>
                  </b-col>
                  <b-col cols="12" class="ml-0 pl-0" v-if="surveyGroupsQuestion.title">
                    <h4>{{ surveyGroupsQuestion.title }}</h4>
                  </b-col>
                  <b-col cols="12" class="ml-0 pl-0 mt-0 pt-0" v-if="surveyGroupsQuestion.description">
                    <h2>{{ surveyGroupsQuestion.description }}</h2>
                  </b-col>
                  <b-row>
                    <b-col
                      cols="12"
                      v-for="(surveyQuestion, questionKey) in surveyGroupsQuestion.surveyQuestions"
                      :key="questionKey"
                    >
                      <h2 class="mb-1">
                        {{ surveyQuestion.questionDescription }}
                      </h2>
                      <div v-if="surveyQuestion.questionType == 1">
                        <b-form-textarea
                          class="p-2"
                          id="textarea"
                          rows="1"
                          readonly
                          disabled
                          v-model="surveyQuestion.answer"
                        />
                      </div>
                      <div v-if="surveyQuestion.questionType == 2">
                        <div
                          v-for="(surveyQuestionAnswer, surveyQuestionAnswerKey) in surveyQuestion.surveyQuestionAnswers"
                          :key="surveyQuestionAnswerKey + '-' + questionKey + '-' + groupsQuestionsKey"
                          class="custom-control custom-radio mb-2"
                        >
                          <input
                            class="custom-control-input"
                            type="radio"
                            disabled
                            :id="'answer-' + surveyQuestionAnswerKey + '-' + questionKey + '-' + groupsQuestionsKey"
                            :name="'answer-' + questionKey + '-' + groupsQuestionsKey"
                            :checked="surveyQuestionAnswer.answerDescription === surveyQuestion.answer"
                          />
                          <label class="custom-control-label" :for="'answer-' + surveyQuestionAnswerKey + '-' + questionKey + '-' + groupsQuestionsKey">
                            <span>{{ surveyQuestionAnswer.answerDescription }}</span>
                          </label>
                        </div>
                      </div>
                      <div v-if="surveyQuestion.questionType == 3">
                        <div
                          v-for="(surveyQuestionAnswer, surveyQuestionAnswerKey) in surveyQuestion.surveyQuestionAnswers"
                          :key="surveyQuestionAnswerKey"
                          class="custom-control custom-checkbox mb-2"
                        >
                          <input
                            class="custom-control-input"
                            type="checkbox"
                            disabled
                            :id="'chk-' + surveyQuestionAnswerKey + '-' + questionKey + '-' + groupsQuestionsKey"
                            :checked="surveyQuestionAnswer.answerDescription === surveyQuestion.answer"
                          />
                          <label class="custom-control-label" :for="'chk-' + surveyQuestionAnswerKey + '-' + questionKey + '-' + groupsQuestionsKey">
                            <span>{{ surveyQuestionAnswer.answerDescription }}</span>
                          </label>
                        </div>
                      </div>
                      <div v-if="surveyQuestion.questionType == 4">
                        <template v-if="surveyQuestion.document">
                          <b-link
                            href="#"
                            @click.prevent="downloadDocument(surveyQuestion.document)"
                          >
                            {{ surveyQuestion.document.fileName }}
                          </b-link>
                        </template>
                        <span v-else>{{ $t('views.surveyresults.show.noDocument') }}</span>
                      </div>
                      <!-- divider między pytaniami -->
                      <hr
                        v-if="questionKey !== surveyGroupsQuestion.surveyQuestions.length - 1"
                        class="mr-2"
                        :class="{ 'mt-5': surveyQuestion.questionType === 3 }"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  name: 'Show',
  components: {
    Loader
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(this.id)
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABSurveysList')
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'EXABSurveyResultsList' })
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      retrieved: 'surveyresults/show/retrieved',
      isLoading: 'surveyresults/show/isLoading'
    })
  },
  methods: {
    downloadDocument (item) {
      new ApiService('e_x_c_m_document_files/' + item.id + '/download').downloadFile(item.fileName)
    },
    ...mapActions({
      retrieve: 'surveyresults/show/retrieve'
    })
  }
}
</script>

<style scoped>

</style>
